import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import globalSettingsStores from '../../../../stores/settings-stores';
import { ScholarshipFundersEntities } from '../../../../api/types/settings/scholarship-funders';
import dateFormat from '../../../../utils/date-format';
import { Dialog } from 'primereact/dialog';
import { DialogAddNewScholarshipFunder } from './components/dialog-add-new-scholarship-funder';
import './scholarship-funders.css';
import { observer } from 'mobx-react-lite';
import { EditTextDialog } from '../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../operations/update-entity-name/settings-entity-types';
import { deleteScholarshipFunderOperation } from './operations/delete-scholarship-funder-operation';

export const ScholarshipFunders = observer(() => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [editFunder, setEditFunder] =
    useState<ScholarshipFundersEntities | null>(null);
  const [deleteFunderId, setDeleteFunderId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const dialogHide = () => {
    setShowDialog(false);
  };

  const dialogDisplay = () => {
    setShowDialog(true);
  };

  const handleEditFunder = (funder: ScholarshipFundersEntities) => {
    setEditFunder(funder);
  };

  const handleSaveFunder = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.SCHOLARSHIP_FUNDER,
      id,
      newName,
      setLoading,
    );
  };

  const handleDeleteFunder = async (funderId: number) => {
    await deleteScholarshipFunderOperation(funderId, setDeleteFunderId);
  };

  return (
    <div>
      <Button
        style={{ height: '30px' }}
        label={'הוספה'}
        onClick={dialogDisplay}
      />
      <div style={{ height: '8px' }} />
      <DataTable
        value={globalSettingsStores.scholarshipFunders}
        loading={isLoading}
        rows={10}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        className="p-datatable-striped"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="funderName"
          header="שם המממן"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="תאריך יצירה"
          sortable
          body={(rowData: ScholarshipFundersEntities) =>
            dateFormat.displayFormatDate(new Date(rowData.createdAt))
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: ScholarshipFundersEntities) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת מממן'}
                onClick={() => handleEditFunder(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת מממן'}
                loading={deleteFunderId === data.id}
                disabled={deleteFunderId !== null}
                onClick={() => handleDeleteFunder(data.id)}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        header="הוספת מממן חדש"
        visible={showDialog}
        onHide={dialogHide}
        style={{
          width: '400px',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
      >
        <DialogAddNewScholarshipFunder closeDialog={dialogHide} />
      </Dialog>

      <EditTextDialog
        id={editFunder?.id}
        value={editFunder?.funderName}
        title="עריכת מממן"
        label="שם המממן"
        loading={loading}
        onSave={handleSaveFunder}
        onHide={() => setEditFunder(null)}
      />
    </div>
  );
});
